import { Box, InputAdornment } from "@mui/material";
import { grey } from "@mui/material/colors";
import { GridEditInputCell } from "@mui/x-data-grid";
import { CustomDatagridPagination } from "components/PimDashboard/CommonComponents/CustomDatagridPagination/CustomDatagridPagination";
import { constraints, CustomDatagridEditCell, datatypes, inputTypes } from "data/globalData";
import {
	cutQtyPrefilledColumn,
	ocSplitQtyChannelSizeAssocObj,
	ocSplitQtyChannelWarehouseAssocObj,
	ocSplitQtyCutQtySplitAssocObj,
	splitQtyTableColumns,
} from "../data";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";
import { LensTwoTone } from "@mui/icons-material";

export const orderQtyStaticColumns = {
	channel_total_qty: {
		name: "Buy Qty",
		key: "channel_total_qty",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	channel_store_grade: {
		name: "Store Grade",
		key: "channel_store_grade",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const totalPercentColumn = {
	name: "TOTAL",
	key: "TOTAL",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.DECIMAL.key,
	constraints: { NOTNULL: false, DISPLAY: true },
};

export const convertSizeStringToStandardInputFormat = (sizeStr) => {
	const size = sizeStr?.toString().toUpperCase();
	if (!size) return size;

	return {
		name: size,
		key: size,
		data_type: datatypes.DECIMAL.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		default_value: 0,
		editable: true,
		renderCell: (params) => (
			<Box sx={{ display: "flex", justifyContent: "center", width: "100%", alignItems: "center" }}>
				<span>{params.value}</span>
				<Box component="span" sx={{ color: "text.secondary", fontSize: "0.875rem", ml: 1, mr: 1 }}>
					%
				</Box>
			</Box>
		),
		renderEditCell: (params) => {
			return <CustomDatagridEditCell {...params} endAndrosment="%" />;
		},
	};
};
export const convertWarehouseStringToStandardInputFormat = (whStr) => {
	const wh = whStr?.toString().toUpperCase();
	if (!wh) return wh;

	return {
		name: wh,
		key: whStr,
		data_type: datatypes.DECIMAL.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		default_value: 0,
		editable: false,
		renderHeader: (col) => (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					width: "100%",
					alignItems: "center",
					background: grey[400],
					p: 1,
					boxSizing: "border-box",
				}}>
				<span>{col.name}</span>
			</Box>
		),
		// renderCell: (params) => (
		// 	<Box sx={{ display: "flex", justifyContent: "center", width: "100%", alignItems: "center" }}>
		// 		<span>{params.value}</span>
		// 		<Box component="span" sx={{ color: "text.secondary", fontSize: "0.875rem", ml: 1, mr: 1 }}>
		// 			%
		// 		</Box>
		// 	</Box>
		// ),
		// renderEditCell: (params) => {
		// 	return <CustomDatagridEditCell {...params} endAndrosment="%" />;
		// },
	};
};

// calaculate channel lev cut Qty

export const calculatefullCostingSplitQtyData = (costingData) => {
	const calChSizeCutQty = costingData[cutQtyPrefilledColumn.key];
	const warehouses = costingData[splitQtyTableColumns.warehouses.key];
	const channels = costingData[splitQtyTableColumns.channels.key];
	const sizes = costingData[splitQtyTableColumns.sizes.key];

	let channelSizeAssoc = [];
	let cutQtyAssoc = [];

	// console.log("sdfghjkjhgfghjvc", costingData);

	// calculate OrderQty
	channels.forEach((channel) => {
		let sizes = costingData[ocSplitQtyChannelSizeAssocObj].filter((row) => row.channel === channel);

		// validation 1: no size rows for channel
		if (!sizes.length) return;

		let chTotalQty = Number(sizes[0].channel_total_qty) || 0;

		let orderTotalQty = 0;

		if (chTotalQty > 0) {
			sizes = sizes.map((row) => {
				const size_qty = Math.floor(chTotalQty * (row.size_qty_precent / 100));
				if (Number.isFinite(size_qty)) {
					orderTotalQty += size_qty;
					return { ...row, size_qty };
				}
				return row;
			});

			if (orderTotalQty > chTotalQty) sizes[0].size_qty -= orderTotalQty - chTotalQty;
			else if (orderTotalQty < chTotalQty) sizes[0].size_qty += chTotalQty - orderTotalQty;
		}

		channelSizeAssoc.push(...sizes);
	});

	// calculate cutQty Data
	const sizeLevTotalOrderQty = channelSizeAssoc.reduce((acc, curr) => {
		acc[curr.size] = (acc[curr.size] || 0) + (curr.size_qty || 0);
		return acc;
	}, {});

	cutQtyAssoc = costingData[ocSplitQtyCutQtySplitAssocObj].map((row) => {
		const denom = sizeLevTotalOrderQty[row.size] || 0;

		// validation 2: avoid NaN / Infinity
		return {
			...row,
			cut_qty_percent: denom > 0 ? roundDecimalValueUptoTwo((row.cut_qty / denom) * 100) : 0,
		};
	});

	// calaculate channel size lev cut Qty

	const sizeLevCutQtyObj = cutQtyAssoc.reduce((acc, row) => {
		acc[row.size] = row;
		return acc;
	}, {});

	let updatedChannelSizeAssoc = [];

	if (calChSizeCutQty)
		sizes.forEach((size) => {
			let filteredSizes = channelSizeAssoc.filter((row) => row.size === size);

			let sizeCutQtyDetails = sizeLevCutQtyObj[size];

			let totalQty = 0;

			filteredSizes = filteredSizes.map((row) => {
				const cut_qty =
					sizeCutQtyDetails.cut_qty_percent > 0 ? Math.floor(row.size_qty * (sizeCutQtyDetails.cut_qty_percent / 100)) : 0;
				if (Number.isFinite(cut_qty)) {
					totalQty += cut_qty;
					return { ...row, cut_qty };
				}
				return row;
			});

			// validation 5: safe adjustment
			if (totalQty > sizeCutQtyDetails.cut_qty) {
				filteredSizes[0].cut_qty = Math.max(0, filteredSizes[0].cut_qty - (totalQty - sizeCutQtyDetails.cut_qty));
			} else if (totalQty < sizeCutQtyDetails.cut_qty) {
				filteredSizes[0].cut_qty += sizeCutQtyDetails.cut_qty - totalQty;
			}

			updatedChannelSizeAssoc.push(...filteredSizes);
		});
	else updatedChannelSizeAssoc = channelSizeAssoc;

	// console.log("dshfuysgdfidgfdh", updatedChannelSizeAssoc, channelSizeAssoc);
	// Wh Qty Calculation
	updatedChannelSizeAssoc = updatedChannelSizeAssoc.map((chSize) => {
		let whRows = chSize[ocSplitQtyChannelWarehouseAssocObj];

		const sizeCutQty = chSize.cut_qty;
		if (!whRows.length) return chSize;
		let totalWhQty = 0;
		whRows = whRows.map((whQty) => {
			const qty = Math.floor(chSize.cut_qty * (whQty.warehouse_qty_precent / 100));
			if (Number.isFinite(qty)) {
				totalWhQty += qty;
				return { ...whQty, qty };
			}
			return whQty;
		});

		// validation 5: safe adjustment
		if (totalWhQty > sizeCutQty) {
			whRows[0].qty = Math.max(0, whRows[0].qty - (totalWhQty - sizeCutQty));
		} else if (totalWhQty < sizeCutQty) {
			whRows[0].qty += sizeCutQty - totalWhQty;
		}

		return {
			...chSize,
			[ocSplitQtyChannelWarehouseAssocObj]: whRows,
		};
	});

	return {
		...costingData,
		[ocSplitQtyChannelSizeAssocObj]: updatedChannelSizeAssoc,
		[ocSplitQtyCutQtySplitAssocObj]: cutQtyAssoc,
	};
};
